import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { esMX } from './catalog';

export type AppLanguage = 'en' | 'es';

// Temporarily paused until Spanish coverage is complete. Keep in sync with the
// other clients and backend/src/common/product-language.ts when re-enabling.
export const TRANSLATIONS_ENABLED = false;

export function resolveLanguage(locale?: string | null): AppLanguage {
  if (!TRANSLATIONS_ENABLED) return 'en';
  return locale?.trim().toLowerCase().startsWith('es') ? 'es' : 'en';
}

const browserLocale =
  typeof navigator === 'undefined'
    ? 'en-US'
    : navigator.languages?.[0] || navigator.language || 'en-US';

void i18n.use(initReactI18next).init({
  lng: resolveLanguage(browserLocale),
  fallbackLng: 'en',
  supportedLngs: TRANSLATIONS_ENABLED ? ['en', 'es'] : ['en'],
  keySeparator: false,
  resources: { en: { translation: {} }, es: { translation: esMX } },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export function applyLanguage(locale?: string | null): AppLanguage {
  const language = resolveLanguage(locale);
  if (i18n.language !== language) void i18n.changeLanguage(language);
  if (typeof document !== 'undefined') document.documentElement.lang = language === 'es' ? 'es-MX' : 'en';
  return language;
}

export { i18n };
